import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

const DoubleColumnContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    margin: 0 auto;

    @media (max-width: ${wideBreakpoints.tablet}) {
        gap: 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: auto;
        grid-template-rows: 1fr 1fr;
    }
`;

export default DoubleColumnContainer;
